import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  actionCloseLaborTicketModal,
  actionSetLaborTicketModalOpen,
} from 'lib/actions';
import { getLaborTicketSplitDraft } from 'lib/selectors/getLaborTicketSplitDraft';
import { getCanResumeSplitDraft } from 'lib/selectors/getCanResumeSplitDraft';

// The split hid the drawer to show the job picker. On unmount, reopen it while
// its ticket is open, so every way out returns the operator to the form.
// Otherwise close the modal, which drops the draft. That covers a ticket that
// closed meanwhile, and the operator sign-in redirect, whose return trip to the
// picker carries no split route state.
const useResumeSplitDraftOnUnmount = (needsOperatorForMES) => {
  const storeDispatch = useDispatch();
  const splitDraft = useSelector(getLaborTicketSplitDraft);
  const canResume = useSelector(getCanResumeSplitDraft);
  const exit = !splitDraft?.splitTime
    ? null
    : canResume && !needsOperatorForMES
    ? 'resume'
    : 'drop';
  const exitRef = useRef(exit);
  // Mirrored through an effect to keep the write out of render.
  useEffect(() => {
    exitRef.current = exit;
  }, [exit]);
  useEffect(() => {
    return () => {
      if (exitRef.current === 'resume') {
        storeDispatch(actionSetLaborTicketModalOpen(true));
      } else if (exitRef.current === 'drop') {
        storeDispatch(actionCloseLaborTicketModal());
      }
    };
  }, [storeDispatch]);
};

export default useResumeSplitDraftOnUnmount;
